import BrowsePage from './browse-page';
export default BrowsePage;